import { createSlice } from '@reduxjs/toolkit'
import { AVAILABLE_COMMUNICATION_BOARD_SECTIONS } from '@/containers/SubscriptionFormPageNew/Components/CommunicationBoard/constants'

const initialState = {
  section: AVAILABLE_COMMUNICATION_BOARD_SECTIONS[0],
  content: '',
  isLoading: false,
  isSaving: false,
  resultError: null,
  resultMessage: null,
}

const setSectionHandler = (state, { payload }) => {
  state.section = payload || initialState.section
  state.content = ''
  state.resultError = null
  state.resultMessage = null
}

const setContentHandler = (state, { payload }) => {
  state.content = String(payload ?? '')
}

const fetchRequestHandler = state => {
  state.isLoading = true
  state.resultError = null
}

const fetchSuccessHandler = (state, { payload }) => {
  state.isLoading = false
  state.content = payload?.content || ''
  state.resultError = null
}

const fetchFailureHandler = (state, { payload }) => {
  state.isLoading = false
  state.resultError = payload || 'Error'
}

const saveRequestHandler = state => {
  state.isSaving = true
  state.resultError = null
  state.resultMessage = null
}

const saveSuccessHandler = (state, { payload }) => {
  state.isSaving = false
  state.resultMessage = payload?.message || ''
  state.resultError = null
}

const saveFailureHandler = (state, { payload }) => {
  state.isSaving = false
  state.resultError = payload?.error || 'Error'
  state.resultMessage = null
}

const resetHandler = state => {
  Object.assign(state, initialState)
}

const slice = createSlice({
  name: 'communicationBoardTools',
  initialState,
  reducers: {
    setSection: setSectionHandler,
    setContent: setContentHandler,
    fetchRequest: fetchRequestHandler,
    fetchSuccess: fetchSuccessHandler,
    fetchFailure: fetchFailureHandler,
    saveRequest: saveRequestHandler,
    saveSuccess: saveSuccessHandler,
    saveFailure: saveFailureHandler,
    reset: resetHandler,
  },
})

export const {
  setSection,
  setContent,
  fetchRequest,
  fetchSuccess,
  fetchFailure,
  saveRequest,
  saveSuccess,
  saveFailure,
  reset,
} = slice.actions

export default slice.reducer
